export class DescriptionToggle {
    constructor() {
        this.maxHeight = 300;
        this.init();
    }
    init() {
        const items = document.querySelectorAll('.traffic-news__item');
        items.forEach(item => {
            const description = item.querySelector('.traffic-news__description');
            if (!description)
                return;
            description.classList.remove('expanded');
            description.style.maxHeight = '';
            description.style.overflow = '';
            if (description.scrollHeight > this.maxHeight) {
                description.classList.add('has-overflow');
                description.style.maxHeight = `${this.maxHeight}px`;
                description.style.overflow = 'hidden';
                description.style.position = 'relative';
                const toggle = document.createElement('div');
                toggle.className = 'traffic-news__toggle';
                toggle.innerHTML = `
          <span class="toggle-label">Mehr anzeigen</span>
          <i class="obb-icon-arrow-down" aria-hidden="true"></i>
        `;
                toggle.classList.add('traffic-news__toggle--collapsed');
                description.appendChild(toggle);
                const icon = toggle.querySelector('.obb-icon-arrow-down');
                const label = toggle.querySelector('.toggle-label');
                toggle.addEventListener('click', () => {
                    const expanded = description.classList.toggle('expanded');
                    if (expanded) {
                        description.style.maxHeight = `${description.scrollHeight + 30}px`;
                        toggle.classList.remove('traffic-news__toggle--collapsed');
                        toggle.classList.add('traffic-news__toggle--expanded');
                        toggle.style.background = 'none';
                        toggle.classList.remove('traffic-news__toggle--collapsed');
                        toggle.classList.add('traffic-news__toggle--expanded');
                        label.textContent = 'Weniger anzeigen';
                        icon === null || icon === void 0 ? void 0 : icon.classList.add('rotated');
                    }
                    else {
                        description.style.maxHeight = `${this.maxHeight}px`;
                        toggle.classList.remove('traffic-news__toggle--expanded');
                        toggle.classList.add('traffic-news__toggle--collapsed');
                        toggle.style.background = '#FFFFFF';
                        label.textContent = 'Mehr anzeigen';
                        icon === null || icon === void 0 ? void 0 : icon.classList.remove('rotated');
                    }
                });
            }
        });
    }
}
export function initDescriptionToggle() {
    new DescriptionToggle();
}
